export const SYSTEM_ADMINISTRATION_PATH = '/SystemAdministration';
export const SYSTEM_ADMINISTRATION_COSTS_PATH = `${SYSTEM_ADMINISTRATION_PATH}/AzureCosts`;

export const isSystemAdministrationPath = (pathname: string): boolean =>
    pathname === SYSTEM_ADMINISTRATION_PATH ||
    pathname.startsWith(`${SYSTEM_ADMINISTRATION_PATH}/`);

// A hard refresh rebuilds AccessInfo asynchronously. The MSAL account and the
// session token can already make isLoggedIn() true while the user identity and
// roles are still empty. Treat that state as "authorization pending" rather
// than "unauthorized" so a valid System Administration deep link is not
// replaced with the dashboard before workspace bootstrap completes.
export const shouldRedirectFromSystemAdministration = (
    currentUserId: string,
    hasSystemAdministratorRole: boolean,
): boolean => currentUserId !== '' && !hasSystemAdministratorRole;

export const isSystemAdministrationAuthorizationPending = (currentUserId: string): boolean =>
    currentUserId === '';
